import { useEffect, useState } from "react";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { DocenteList } from "../../../modules/docente/DocenteList";
import { TITULO_DOC_LIST, TITULO_IDIOMA_LIST } from "../../../utils/constantes";
import { ShowButtonsPaginacion } from "../../../utils/paginacion/ShowButtonsPaginacion";
import { paginacion } from "../../../utils/paginacion/paginacion";
import { getAllDocentes } from "../../../services/docente.service";

export const DocentePage = () => {
  const [busqueda, setBusqueda] = useState("");
  const [docentes, setDocentes] = useState(null);
  const DIR_ICONO_DOC = "img/iconos/titulo de docente (con la pizarra).svg";

  useEffect(() => {
    obtenerDocentes();
  }, []);

  const obtenerDocentes = async () => {
    await getAllDocentes()
      .then((docentes) => setDocentes(docentes))
      .catch((err) => console.log(err));
  };

  const handleDelete = (idDocente) => {
    setDocentes((prevDocentes) =>
      prevDocentes.filter((doc) => doc.docente.idDocente !== idDocente)
    );
  };

  const docentesFiltrados = docentes?.filter((docente) => {
    const texto = busqueda.toLowerCase();
    const persona = docente?.persona || {};
    const usuario = docente?.usuario || {};
    
    const nombre = persona.nombre?.toLowerCase() || "";
    const apellido = persona.apellido?.toLowerCase() || "";
    const codigo = usuario.username?.toLowerCase() || "";  // <- Aquí está el username
    const celular = persona.celular?.toLowerCase() || "";
    const ci = persona.ci?.toLowerCase() || "";
    const correo = persona.correo?.toLowerCase() || "";
    const sexo = persona.sexo?.toLowerCase() || "";
  
    return (
      nombre.includes(texto) ||
      apellido.includes(texto) ||
      codigo.includes(texto) ||
      celular.includes(texto) ||
      ci.includes(texto) ||
      correo.includes(texto) ||
      sexo.includes(texto)
    );
  });
  
  

  return (
    <ContenedorPageTemplate objetos={docentes} dirIcono={DIR_ICONO_DOC} titulo={TITULO_DOC_LIST}>
      <div className="flex flex-col justify-start items-start">
        <p>
          Total de docentes: <span>{docentesFiltrados?.length}</span>
        </p>
      </div>
      <div className="flex gap-4 py-3">
        <input
          type="text"
          placeholder="Buscar por nombre, apellido, código, teléfono, CI, correo o género"
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          className="flex-1 text-black border shadow-sm rounded-xl py-3 px-4 focus:ring-1 focus:border-blue-500 focus:ring-blue-300 transition-colors hover:border-blue-500 border-slate-200"
        />
      </div>
      <DocenteList docentes={docentesFiltrados} onDelete={handleDelete} />
    </ContenedorPageTemplate>
  );
};
